
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexJdDXC2GLjRMeta } from "/codebuild/output/src3828577823/src/pages/index.vue?macro=true";
import { default as aboutwnBEcFP83IMeta } from "/codebuild/output/src3828577823/src/pages/about.vue?macro=true";
import { default as dataohUuxipkVmMeta } from "/codebuild/output/src3828577823/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptiono5qtOHGoIsMeta } from "/codebuild/output/src3828577823/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningahbnxQZ8MzMeta } from "/codebuild/output/src3828577823/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyiz8yl4y7cGMeta } from "/codebuild/output/src3828577823/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45account9ehhHXOeGZMeta } from "/codebuild/output/src3828577823/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statueQDrkju0DVGMeta } from "/codebuild/output/src3828577823/src/pages/account-settings/statue.vue?macro=true";
import { default as supportHaDmNFYlsoMeta } from "/codebuild/output/src3828577823/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsvVg9LnboReMeta } from "/codebuild/output/src3828577823/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountcOaKjwd58cMeta } from "/codebuild/output/src3828577823/src/pages/activate-account.vue?macro=true";
import { default as companynNJHzNw6uUMeta } from "/codebuild/output/src3828577823/src/pages/admin/company.vue?macro=true";
import { default as consents0EwZZi9vIeMeta } from "/codebuild/output/src3828577823/src/pages/admin/consents.vue?macro=true";
import { default as leadsm3x9CpQuHTMeta } from "/codebuild/output/src3828577823/src/pages/admin/leads.vue?macro=true";
import { default as paymentsvaqGg9upJ0Meta } from "/codebuild/output/src3828577823/src/pages/admin/payments.vue?macro=true";
import { default as premiumjnJzf5uTsNMeta } from "/codebuild/output/src3828577823/src/pages/admin/premium.vue?macro=true";
import { default as profilesDS76qzLAhjMeta } from "/codebuild/output/src3828577823/src/pages/admin/profiles.vue?macro=true";
import { default as userswhsQ3MVNTbMeta } from "/codebuild/output/src3828577823/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordRTZ69OMGRUMeta } from "/codebuild/output/src3828577823/src/pages/change-password.vue?macro=true";
import { default as _91id_93iEADiII6rDMeta } from "/codebuild/output/src3828577823/src/pages/chat/[id].vue?macro=true";
import { default as aig8wgyx8Ew0Meta } from "/codebuild/output/src3828577823/src/pages/chat/ai.vue?macro=true";
import { default as index0ZPc7aQD8RMeta } from "/codebuild/output/src3828577823/src/pages/chat/index.vue?macro=true";
import { default as chat9Las2V0aGDMeta } from "/codebuild/output/src3828577823/src/pages/chat.vue?macro=true";
import { default as _91id_93CU2ApkT0rNMeta } from "/codebuild/output/src3828577823/src/pages/client/profile/[id].vue?macro=true";
import { default as indexM3zaxDKj64Meta } from "/codebuild/output/src3828577823/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93iJKgBUHjdfMeta } from "/codebuild/output/src3828577823/src/pages/contacts/[id].vue?macro=true";
import { default as indexX2IN6g4vPrMeta } from "/codebuild/output/src3828577823/src/pages/contacts/index.vue?macro=true";
import { default as contactsQft5uYQyOEMeta } from "/codebuild/output/src3828577823/src/pages/contacts.vue?macro=true";
import { default as _91userId_93X8oYSQyxBRMeta } from "/codebuild/output/src3828577823/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as index4dF60qoMzmMeta } from "/codebuild/output/src3828577823/src/pages/login/index.vue?macro=true";
import { default as register_45successTRV4qXBbCjMeta } from "/codebuild/output/src3828577823/src/pages/login/register-success.vue?macro=true";
import { default as loginLBb53VnyX8Meta } from "/codebuild/output/src3828577823/src/pages/login.vue?macro=true";
import { default as logoutD569AolNWHMeta } from "/codebuild/output/src3828577823/src/pages/logout.vue?macro=true";
import { default as consentsYsgbziyU5bMeta } from "/codebuild/output/src3828577823/src/pages/manager/consents.vue?macro=true";
import { default as integrationsfggAR7pbdmMeta } from "/codebuild/output/src3828577823/src/pages/manager/integrations.vue?macro=true";
import { default as leadsvQaCsgHOVTMeta } from "/codebuild/output/src3828577823/src/pages/manager/leads.vue?macro=true";
import { default as paymentsbXD3mJbk6aMeta } from "/codebuild/output/src3828577823/src/pages/manager/payments.vue?macro=true";
import { default as profilerHHywxKzeNMeta } from "/codebuild/output/src3828577823/src/pages/manager/profile.vue?macro=true";
import { default as teamGLwurkFzA3Meta } from "/codebuild/output/src3828577823/src/pages/manager/team.vue?macro=true";
import { default as indexol8X4kx7KJMeta } from "/codebuild/output/src3828577823/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientRGfQqjhYvoMeta } from "/codebuild/output/src3828577823/src/pages/marketplace/search/[catId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src3828577823/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as marketplaceT3R2U7NIjQMeta } from "/codebuild/output/src3828577823/src/pages/marketplace.vue?macro=true";
import { default as subscribeBHkCNGOIlnMeta } from "/codebuild/output/src3828577823/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientGPmrOqatuRMeta } from "/codebuild/output/src3828577823/src/pages/orders/find.client.vue?macro=true";
import { default as my_46client3OX7IirF6eMeta } from "/codebuild/output/src3828577823/src/pages/orders/my.client.vue?macro=true";
import { default as privacyF9RjVsHrvUMeta } from "/codebuild/output/src3828577823/src/pages/privacy.vue?macro=true";
import { default as index8TECBi3QrfMeta } from "/codebuild/output/src3828577823/src/pages/recover/index.vue?macro=true";
import { default as successvqc2CopytLMeta } from "/codebuild/output/src3828577823/src/pages/register/success.vue?macro=true";
import { default as _91id_93rIsH7KieBEMeta } from "/codebuild/output/src3828577823/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexALbyBg1FMwMeta } from "/codebuild/output/src3828577823/src/pages/sales/profile/index.vue?macro=true";
import { default as statueTBfcG6l0QfMeta } from "/codebuild/output/src3828577823/src/pages/statue.vue?macro=true";
import { default as successyAOuW495H8Meta } from "/codebuild/output/src3828577823/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubTjSIgKswEYMeta } from "/codebuild/output/src3828577823/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubTjSIgKswEY } from "/codebuild/output/src3828577823/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexJdDXC2GLjRMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutwnBEcFP83IMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutwnBEcFP83IMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsvVg9LnboReMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsvVg9LnboReMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src3828577823/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountcOaKjwd58cMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountcOaKjwd58cMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companynNJHzNw6uUMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companynNJHzNw6uUMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consents0EwZZi9vIeMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consents0EwZZi9vIeMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadsm3x9CpQuHTMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadsm3x9CpQuHTMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsvaqGg9upJ0Meta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsvaqGg9upJ0Meta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumjnJzf5uTsNMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumjnJzf5uTsNMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesDS76qzLAhjMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesDS76qzLAhjMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: userswhsQ3MVNTbMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: userswhsQ3MVNTbMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordRTZ69OMGRUMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordRTZ69OMGRUMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/change-password.vue")
  },
  {
    name: chat9Las2V0aGDMeta?.name,
    path: "/en/chat",
    meta: chat9Las2V0aGDMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___en",
    path: ":id()",
    meta: _91id_93iEADiII6rDMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "ai",
    meta: aig8wgyx8Ew0Meta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/chat/ai.vue")
  },
  {
    name: "chat___en",
    path: "",
    meta: index0ZPc7aQD8RMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/chat/index.vue")
  }
]
  },
  {
    name: chat9Las2V0aGDMeta?.name,
    path: "/pl/chat",
    meta: chat9Las2V0aGDMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___pl",
    path: ":id()",
    meta: _91id_93iEADiII6rDMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___pl",
    path: "ai",
    meta: aig8wgyx8Ew0Meta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/chat/ai.vue")
  },
  {
    name: "chat___pl",
    path: "",
    meta: index0ZPc7aQD8RMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/chat/index.vue")
  }
]
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93CU2ApkT0rNMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93CU2ApkT0rNMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexM3zaxDKj64Meta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexM3zaxDKj64Meta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/client/profile/index.vue")
  },
  {
    name: contactsQft5uYQyOEMeta?.name,
    path: "/en/contacts",
    meta: contactsQft5uYQyOEMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93iJKgBUHjdfMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexX2IN6g4vPrMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsQft5uYQyOEMeta?.name,
    path: "/pl/contacts",
    meta: contactsQft5uYQyOEMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93iJKgBUHjdfMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexX2IN6g4vPrMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93X8oYSQyxBRMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93X8oYSQyxBRMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexJdDXC2GLjRMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexJdDXC2GLjRMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/index.vue")
  },
  {
    name: loginLBb53VnyX8Meta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src3828577823/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: index4dF60qoMzmMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successTRV4qXBbCjMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: loginLBb53VnyX8Meta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src3828577823/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: index4dF60qoMzmMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successTRV4qXBbCjMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutD569AolNWHMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutD569AolNWHMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsYsgbziyU5bMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsYsgbziyU5bMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsfggAR7pbdmMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsfggAR7pbdmMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsvQaCsgHOVTMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsvQaCsgHOVTMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsbXD3mJbk6aMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsbXD3mJbk6aMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profilerHHywxKzeNMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profilerHHywxKzeNMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamGLwurkFzA3Meta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamGLwurkFzA3Meta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/manager/team.vue")
  },
  {
    name: marketplaceT3R2U7NIjQMeta?.name,
    path: "/en/marketplace",
    meta: marketplaceT3R2U7NIjQMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src3828577823/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientRGfQqjhYvoMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3828577823/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceT3R2U7NIjQMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaceT3R2U7NIjQMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src3828577823/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientRGfQqjhYvoMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3828577823/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribeBHkCNGOIlnMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribeBHkCNGOIlnMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientGPmrOqatuRMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3828577823/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientGPmrOqatuRMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3828577823/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46client3OX7IirF6eMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3828577823/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46client3OX7IirF6eMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3828577823/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacyF9RjVsHrvUMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacyF9RjVsHrvUMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: index8TECBi3QrfMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: index8TECBi3QrfMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src3828577823/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src3828577823/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93rIsH7KieBEMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93rIsH7KieBEMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexALbyBg1FMwMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexALbyBg1FMwMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statueTBfcG6l0QfMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statueTBfcG6l0QfMeta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successyAOuW495H8Meta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successyAOuW495H8Meta || {},
    component: () => import("/codebuild/output/src3828577823/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubTjSIgKswEYMeta?.name,
    path: "/old-page",
    component: component_45stubTjSIgKswEY
  }
]